// extracted by mini-css-extract-plugin
export default {"root":"UARK9jT79o3lVUofK_7U","win":"kr4PGs8cnC9dCPOhcZqw","buttons":"IldYqTMiStYVKLtfWQK7","placeHolderShimmer":"tfQe3H6DxpgpWQSF9LoD"};